import { Link, useNavigate } from 'react-router-dom';
import css from './ItemCard.module.scss';
import TableImage from '../atoms/TableImage';
import { Menu, Item, useContextMenu } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.css';
import Switch from '../atoms/Switch';
import { addItem, deleteItem } from 'src/slices/item';
import { useDispatch, useSelector } from 'react-redux';

import { updateItem } from 'src/slices/item';
import { approveResource } from 'src/slices/employee';
// import { useEffect } from "react";
// import { handleStatus } from "src/slices/utils";
// import { clearState } from "src/slices/employee";
import Pill from '../atoms/Pill';
import { toast } from 'react-toastify';
import Button from '../atoms/Button';
import { checkPermissions } from '../../slices/utils';

export default function ItemCard({ ...item }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const MENU_ID_ITEM = 'item-menu-id' + item.id;
  const { permissions } = useSelector((state) => state.auth);

  const { show } = useContextMenu({
    id: MENU_ID_ITEM,
  });

  // CHANGE ME
  function handleDelete(deleteFunction) {
    const ConfirmActionModal = ({ closeToast, toastProps }) => (
      <div>
        Are you sure you want to delete this item? This action cannot be undone.
        <div className={css.buttons}>
          <Button
            color="green"
            action={() => dispatch(deleteFunction(item.id))}
            label={`Delete "${item.name}"`}
          ></Button>
          <Button color="red" label={'Dismiss'}></Button>
        </div>
      </div>
    );
    toast(ConfirmActionModal, { autoClose: false });
  }

  const handleApprove = () => {
    dispatch(
      approveResource({
        resource: 'item',
        data: { items: JSON.stringify([item.id]) },
      }),
    );
  };

  // This is what the switch button does
  function toggleHidden() {
    dispatch(
      updateItem({
        id: item.id,
        status: item.status == 'active' ? 'hidden' : 'active',
      }),
    );
  }
  const handleClick = (e) => {
    navigate(`/items/${item.id}`);
  };

  // By Shahriar
  function duplicateItem(item) {
    const data = {
      ...item,
      restrictions: JSON.stringify(item.restrictions),
    };
    dispatch(addItem(data));
  }

  return (
    // <Link to={`/items/${item.id}`}>
    <>
      <div
        className={`${css.card} ${item.status === 'hidden' ? css.hidden : undefined}`}
        onClick={handleClick}
        onContextMenu={show}
      >
        <TableImage
          iconUnicode=""
          src={item.photos?.[0]}
          type="rect"
          alt={item.name}
          boxStyles={{
            borderRadius: '16px',
          }}
        />
        <div className={css['details']}>
          <p className={css['name']}>{item.name}</p>
          <p className={css['price']}>${item.price.toFixed(2)}</p>
          <p className={css['price']}>
            {item.qty.value} {item.qty.units}
          </p>
          {item.status === 'hidden' && (
            <Pill label="hidden" color="orange" variant="secondary" iconLeft="fad fa-eye-slash" />
          )}
        </div>

        <div
          className={css['options-container']}
          onClick={(e) => {
            // FIXME: Not working, clicking three dots still navigates
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          {checkPermissions(
            permissions,
            {
              ...(item.status == 'pending' && {
                update: ['pendingItems', { create: ['pendingItems'] }],
              }),
              ...(item.status != 'pending' && {
                update: ['items', { create: ['items'] }],
              }),
            },
            true,
          ).hasPermission && <i className={`far fa-ellipsis-v ${css.options}`} onClick={show} />}
        </div>
      </div>

      {checkPermissions(
        permissions,
        {
          ...(item.status == 'pending' && {
            update: ['pendingItems', { create: ['pendingItems'] }],
          }),
          ...(item.status != 'pending' && {
            update: ['items', { create: ['items'] }],
          }),
        },
        true,
      ).hasPermission && (
        <Menu id={MENU_ID_ITEM} className={css.menu}>
          {item.status !== 'pending' ? (
            <>
              {permissions.update.includes('items') && (
                <Item className={css.item}>
                  <Link to={`/items/${item.id}`}>
                    <span className={`${css['menu-option']}`}>
                      <i className="fad fa-pencil" />
                      Edit
                    </span>
                  </Link>
                </Item>
              )}

              <Item className={css.item} onClick={() => duplicateItem(item)}>
                <span className={`${css['menu-option']}`}>
                  <i className="fad fa-copy" />
                  Duplicate
                </span>
              </Item>

              {permissions.update.includes('items') && (
                <Item className={css.item} onClick={toggleHidden}>
                  <span className={css['menu-option']}>
                    <i className={`fad fa-${item.status === 'hidden' ? 'eye' : 'eye-slash'}`} />
                    {item.status === 'hidden' ? 'Unhide' : 'Hide'}
                  </span>
                </Item>
              )}

              {permissions.delete.includes('items') && (
                <Item
                  onClick={() => handleDelete((itemId) => dispatch(deleteItem(itemId)))}
                  className={`${css.item} ${css['item--del']}`}
                >
                  <span className={`${css['menu-option']} ${css['option--del']}`}>
                    <i className="fad fa-trash" />
                    Delete
                  </span>
                </Item>
              )}
            </>
          ) : (
            <>
              {permissions.approve.includes('items') && (
                <Item className={`${css.item} ${css['item--approve']}`} onClick={handleApprove}>
                  <span className={`${css['menu-option']} ${css['option--approve']}`}>
                    <i className="fad fa-check" />
                    Approve
                  </span>
                </Item>
              )}

              {permissions.update.includes('pendingItems') && (
                <Item className={css.item}>
                  <Link to={`/items/${item.id}`}>
                    <span className={`${css['menu-option']}`}>
                      <i className="fad fa-pencil" />
                      Edit
                    </span>
                  </Link>
                </Item>
              )}
              {/* {permissions.delete.includes('pendingItems') && (
								<Item
									onClick={handleDelete}
									className={`${css.item} ${css['item--del']}`}>
									<span className={`${css['menu-option']} ${css['option--del']}`}>
										Reject
										<i className='fad fa-times' />
									</span>
								</Item>
							)} */}
            </>
          )}
        </Menu>
      )}

      {/* </Link> */}
    </>
  );
}
